const APIRequest = require('components/api_request.js');
const { MobileDetection } = require('@reverbdotcom/discovery-ui');
const { UI } = require('components/legacy/ui.js');

function trackProductView() {
  var trackViewPath = $('[data-track-view-path]').data('track-view-path');

  if (trackViewPath) {
    APIRequest.post(trackViewPath);
  }
}

function bindWatchUnwatch() {
  if (!UI.isLoggedIn()) { return; }

  var watchLink = '[data-bind=\'watch-link\']';
  var unwatchLink = '[data-bind=\'unwatch-link\']';
  var response = '[data-bind=\'watchlist-response\']';

  var displayResponse = function ($clicked) {
    $clicked.toggleClass('hide');
    $clicked.siblings(watchLink).toggleClass('hide');
    $clicked.siblings(unwatchLink).toggleClass('hide');
    $clicked.siblings(response).stop().slideDown('fast').delay(3000).slideUp('fast');
  };

  $(document).on('click', watchLink, function () {
    var $clicked = $(this);
    var watchlistLink = $(watchLink).data('watchlist-link');
    $clicked.siblings(response).html(I18n.t('js.watchList.itemAdded',
      { link_open: `<a href="${watchlistLink}">`, link_close: '</a>' })
    );
    displayResponse($clicked);
  });

  $(document).on('click', unwatchLink, function () {
    var $clicked = $(this);
    $clicked.siblings(response).html(I18n.t('js.watchList.itemRemoved'));
    displayResponse($clicked);
  });
}

function bindInlineOfferButtonToPopup() {
  // Mobile browsers fall through to a regular html request for the lightbox
  if (MobileDetection.isMobileBrowser()) { return; }

  var inline_offer_form = $('form#inline_offer');
  var make_offer_button = $('#make_offer_button');
  var inline_price = $('#inline_offer_price');

  make_offer_button.on('click', function (e) {
    e.preventDefault();
    if (!UI.isLoggedIn()) { return; }

    if (inline_price.val()) {
      UI.Ajax.lightbox($(this).prop('href') + '?price=' + inline_price.val());
    }
  });

  inline_offer_form.submit(function (e) {
    e.preventDefault();
    make_offer_button.click();
  });
}

function init() {
  bindInlineOfferButtonToPopup();
  bindWatchUnwatch();
  trackProductView();
}


$(init);

module.exports = {
  init,
};



// WEBPACK FOOTER //
// ./javascripts/components/products_show.js